module.exports = __webpack_public_path__ + "img/Icon-feather-send.fbd4cd14.svg";